import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	indent: {
		id: 'fabric.editor.indent',
		defaultMessage: 'Indent',
		description: 'Indent a list item, paragraph or heading',
	},
	outdent: {
		id: 'fabric.editor.outdent',
		defaultMessage: 'Outdent',
		description: 'Outdent a list item, paragraph or heading',
	},
});
